





















































import { SfSection } from '@storefront-ui/vue';
import {
  PropType, defineComponent, toRef
} from '@nuxtjs/composition-api';
import { useProductsWithCommonProductCardProps } from '~/modules/catalog/category/components/views/useProductsWithCommonCardProps';
import ProductCard from '~/modules/catalog/category/components/views/ProductCard.vue';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import Carousel from '~/components/Home/Carousel.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import useWishlist from '~/modules/wishlist/composables/useWishlist';
import type { Product } from '~/modules/catalog/product/types';

export default defineComponent({
  components: {
    SfSection,
    Carousel,
    ProductCard,
    CategoryProductPrice,
    SkeletonLoader,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { addOrRemoveItem } = useWishlist();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const products = toRef(props, 'products');
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);

    const addItemToWishlist = async (product) => {
      await addOrRemoveItem({ product });
    };

    const settings = {
      type: 'slider',
      rewind: true,
      perView: 4,
      slidePerPage: true,
      gap: 20,
      breakpoints: {
        1023: {
          perView: 1,
          gap: 10,
          peek: {
            before: 0,
            after: 35,
          },
        },
      },
    };

    return {
      productsWithCommonProductCardProps,
      settings,
      addItemToWishlist
    };
  },
});
